import { React } from 'react';
import { Flex, Text, Checkbox } from '@chakra-ui/react';
import { Controller, useFormContext } from 'react-hook-form';

function SoftSkillsCheckbox({ skillA, skillB }) {
  const methods = useFormContext();

  return (
    <Controller
      name='Communication_Skills'
      control={methods.control}
      render={({ field: { onChange, value } }) => {
        const curatedValue = value ?? [];

        const handleChange = e => {
          // If target becomes checked, filter out both skills, then let's add it's value to the array
          if (e.target.checked) {
            onChange([
              ...(curatedValue ? curatedValue.filter(option => option !== skillA && option !== skillB) : []),
              e.target.value,
            ]);
          } // Else it means it was already present, so just filter out both skills
          else
            onChange([
              ...(curatedValue !== undefined
                ? curatedValue.filter(option => option !== skillA && option !== skillB)
                : []),
            ]);
        };

        return (
          <Flex
            width='100%'
            minWidth='250px'
            justifyContent='center'
            flexDirection='row'
            gap={4}
            backgroundColor='#F1F6FF'
            borderRadius='10px'
            height='28px'>
            <Checkbox
              size='lg'
              value={skillA}
              isChecked={!!value?.find(skill => skill === skillA)}
              onChange={handleChange}
              justifyContent='flex-end'>
              <Text
                fontSize='12px'
                width='max-content'
                color={curatedValue.includes(skillA) ? 'blue.500' : 'black'}
                fontWeight={curatedValue.includes(skillA) ? '600' : '400'}>
                {skillA}
              </Text>
            </Checkbox>
            <Checkbox
              size='lg'
              value={skillB}
              isChecked={!!value?.find(skill => skill === skillB)}
              onChange={handleChange}>
              <Text
                fontSize='12px'
                width='max-content'
                color={curatedValue.includes(skillB) ? 'blue.500' : 'black'}
                fontWeight={curatedValue.includes(skillB) ? '600' : '400'}>
                {skillB}
              </Text>
            </Checkbox>
          </Flex>
        );
      }}
    />
  );
}

export default SoftSkillsCheckbox;
